export default __webpack_public_path__ + "static/bariol_serif_bold-webfont-1d04363e067cf7102f1a987e52940683.woff2";